var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"body"},[_c('Diagram',{ref:"Diagram",attrs:{"src":_vm.currentWireURL,"isFull":_vm.isFull},on:{"onCancelFull":_vm.onCancelFull}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }